'use client';

import { RiRobot2Line } from '@remixicon/react';

import { ProductHero } from '@/components/product-hero';

/**
 * AI Ajan sayfasının açılışı. Kap, küre ve hareket ortak bileşende
 * (`product-hero.tsx`) — dört ürün sayfası aynı açılışı kullanıyor (14 Eki
 * 2026'da buradan oraya çıkarıldı).
 *
 * İkon kutusuz (DESIGN.md §3) ve `RiRobot2Line`: parıltı ikonu yasak, ajan
 * işinin ikonu bu.
 */
export function AgentHero() {
  return <ProductHero ns="featuresAgent.hero" icon={<RiRobot2Line size={18} aria-hidden="true" />} />;
}
